import { render, staticRenderFns } from "./view-general-information.vue?vue&type=template&id=54a68188&scoped=true"
import script from "./view-general-information.vue?vue&type=script&lang=js"
export * from "./view-general-information.vue?vue&type=script&lang=js"
import style1 from "./view-general-information.vue?vue&type=style&index=1&id=54a68188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a68188",
  null
  
)

export default component.exports